<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import ReportPeriodFilterBar from "@/components/Reporting/ReportPeriodFilterBar.vue";
import {ref, computed} from "vue";
import {useReportingStore} from "@/store/reporting";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import HollandCodeDistributionReportGraphs
  from "@/pages/Insights/ReportsDetailPage/components/HollandCodeDistributionReportGraphs.vue";

const reportingStore = useReportingStore();
const metric = ref();
const reportData = ref();
const showReport = ref(false);

reportingStore.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  {text: "Insights", to: {name: "reports"}},
  {text: "Worker Type Distribution Report", to: null}
]);

async function runReport() {
  showReport.value = false;
  metric.value = null;
  reportData.value = null;
  await fetchMetricData();
  await fetchReportData();
  showReport.value = true;
}

function resetReport() {
  metric.value = null;
  reportData.value = null;
  showReport.value = false;
}

async function fetchReportData() {
  reportData.value = await reportingStore.fetchReport("holland-code-distribution");
}

async function fetchMetricData() {
  metric.value = await reportingStore.fetchReport("users-completed-holland-code-ratio");
}

</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="Worker Type Distribution Report"
      description="Explore user the distribution of Worker Types"
    />

    <ReportPeriodFilterBar
      :show-filters="true"
      :show-time-frame="false"
      :show-time-frame-switch="true"
      :show-run-report-button="true"
      @run-report="runReport"
      @reset-filters="resetReport"
    />

    <template v-if="showReport">
      <v-row>
        <v-col cols="12">
          <UsageSummaryMetricTiles
            :data="metric"
            category-title="Users"
            category-icon="fa fa-barcode"
            completed-label="Complete"
            pending-label="Incomplete"
            percentage-label="Completion Rate"
          />
        </v-col>
      </v-row>

      <template v-if="reportData && !Object.keys(reportData).includes('primary')">
        <v-row v-if="!reportData.primary">
          <v-col cols="12" class="text-center my-12">
            <h1 class="grey--text">
              No data available.
            </h1>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <HollandCodeDistributionReportGraphs :report-data="reportData" />
      </template>

    </template>
  </authenticated-layout>
</template>

<style scoped>

</style>
